import { MedicalCode, MedicalCodeControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

interface useUpdateCataLogCodeParams {
  values: MedicalCode;
  xTENANTID?: string;
}

/**
 * @author rajkumar rathod
 */
export const useUpdateCataLogCode = () =>
  useMutationWithLoading(async (params: useUpdateCataLogCodeParams) =>
    new MedicalCodeControllerApi(getConfigObject()).updateMedicalCode(
      params.values,
      params.xTENANTID
    )
  );
